





import { Component, Vue } from 'vue-property-decorator'
import HomeModule from '@api/module/customer/basic-data/BasicDataModule'

@Component
export default class extends Vue {
  get portalFooterDescribe() {
    return (
      HomeModule.currentUnit.portalFooterDescribe ||
      '<p><span>© Copyright 2020 59iedu.com ALL Rights Reserved.</span><span class="ml10">福建华博教育科技股份有限公司 版权所有</span></p><p><span class="ml10"><a href="http://beian.miit.gov.cn" target="_blank">闽ICP备08103886号-2</a></span><span class="ml10"></span></p>'
    )
  }
}
